export default {
	title: "Web3",
	rule: "Descrizione delle regole",
	safe: "Sicurezza dei fondi",
	balance: {
		total: "Importo totale",
		yesterday: "Guadagni di ieri",
		cumulatively: "Guadagni cumulativi",
		in: "Importo versato",
		out: "Importo prelevato",
		available: "Saldo disponibile"
	},
	actions: {
		in: "Versamento",
		out: "Prelievo"
	},
	type: ["Tutti", "Versamento", "Prelievo", "Guadagni"],
	TransactionPassword: "Password di transazione",
	Amount: "Importo",
	date: "Data"
};
